import React, { FC } from 'react';
import { GenInternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import { TypeMyAccountPageTranslations } from '@/utils/translations/types/TypeMyAccountPageTranslations';
import {
  trackItemClickedEvent,
  CLICKED_ITEM_TYPES,
  PAGE_LOCATIONS,
  CTA_NAMES,
} from '@/utils/rudderstack';
import { getLocaleDomain } from '@/utils/helpers';

export type ReferAFriendTileProps = {
  t: TypeMyAccountPageTranslations;
  userUuid: string;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
  classes?: string | undefined;
};

const ReferAFriendTile: FC<ReferAFriendTileProps> = ({
  t,
  tile,
  locale,
  classes,
}) => {
  const baseUrl = getLocaleDomain(locale);
  const referralPath = '/pages/refer-a-friend';
  const prismLink = `${baseUrl}${referralPath}`;

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: prismLink,
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.REFER_A_FRIEND_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      description={tile.description}
      titleDecorator={
        <GenInternalLink
          href={referralPath}
          cta={t.viewCta}
          onClick={sendItemClickedEvent}
        />
      }
      classes={classes}
    />
  );
};

export default React.memo(ReferAFriendTile);
